// extracted by mini-css-extract-plugin
export var heroImage = "_dx-1";
export var modal = "_dx-0";